import { BodyDecoder, BodyEncoder } from '@iotize/tap/client/api';

import { NumberConverter } from './number-converter';

function swapMap(val: { [key: string]: any }): { [key: string]: any } {
  var ret: { [key: string]: any } = {};
  for (var key in val) {
    ret[val[key]] = key;
  }
  return ret;
}

export class MultipleMaskConverter<OutputType>
  implements BodyEncoder<OutputType[]>, BodyDecoder<OutputType[]>
{
  protected _mapping: { [key: number]: OutputType };
  // protected static _instance: UniqMaskDecoder;

  constructor(mapping: any) {
    this._mapping = mapping;
    // this._mapping[0x00] = (null as any as OutputType);
    // this._mapping[0x01] = (null as any as OutputType);
  }

  public decode(body: Uint8Array): OutputType[] {
    return MultipleMaskConverter.decodeAll<OutputType>(body, this._mapping);
  }

  /**
   * TODO check that not use more than the first 7 bits
   * @param types
   */
  public encode(types: OutputType[]): Uint8Array {
    return MultipleMaskConverter.encodeAll(types, this._mapping);
  }

  public static encodeAll<T>(values: T[], mapping: any): Uint8Array {
    var _reverseMapping = swapMap(mapping);
    var result = 0x0;
    for (var type of values) {
      if ((type as any) in _reverseMapping) {
        var mask = parseInt(_reverseMapping[type as any]);
        result = result | mask;
      }
    }
    return Uint8Array.from([result & 0xff]);
  }

  public static decodeAll<T>(value: Uint8Array | number, mapping: any): T[] {
    var results = [];
    if (typeof value !== 'number') {
      value = NumberConverter.fromOpaqueMsb(
        value,
        Math.min(value.length * 8, 32),
      );
    }
    for (var key in mapping) {
      var mask = parseInt(key);
      if (mask == 0 && value == 0) {
        results.push(mapping[mask]);
      } else if ((mask & value) != 0) {
        results.push(mapping[mask]);
      }
    }
    return results;
  }

  // public static instance(){
  //     if (!StringDecoder._instance){
  //         StringDecoder._instance = new StringDecoder();
  //     }
  //     return StringDecoder._instance;
  // }
}
